$(document).ready(function(){


    var filter_container = $('.products-list-display-filters, .shop-area-mobile-filters-section-selected-container');
    var filters_items = filter_container.find('.filter-item');

    var isFilterAdded = false;

    function updateQuickFiltersNav(){
        setTimeout(() => {
            if($('.quickfilter_slider').length > 0){
                var $el = $('.quickfilter_slider');
                console.log('update: ' + ($el.scrollLeft() + $el.outerWidth()) + ' - ' + $el.prop("scrollWidth"))
                if($el.scrollLeft() + $el.outerWidth() >= $el.prop("scrollWidth") - 1){
                    $('.quickfilters-next').addClass('hide');
                    console.log('next hide')
                }else{
                    $('.quickfilters-next').removeClass('hide id-disabled');
                    console.log('next show')
                }
                setTimeout(() => {
                    $('.quickfilters-prev').css('visibility', 'visible');
                    $('.quickfilters-next').css('visibility', 'visible');
                }, 300);
            }
        }, 500);
    }

    if($('.quickfilter_slider').length > 0){
        var quickfilterSlider = new SnapSlider('.quickfilter_slider', {
            id: 'quickfilters',
            nav: '.quickfilters-nav',
            start: 'first',
            // prev: '.quickfilters-prev',
            // next: '.quickfilters-next',
            on: {
                'load': () => {
                    updateQuickFiltersNav();
                    console.log('loaded')
                    if($('.quickfilter_slider .slide').length == 0){
                        $('.quickfilters-prev').addClass('hide');
                    }else{
                        $('.quickfilters-prev').removeClass('hide');
                    }
                },
                'change': () => {
                    $('.quickfilters-prev').css('visibility', 'hidden');
                    $('.quickfilters-next').css('visibility', 'hidden');

                    if($('.quickfilter_slider .slide').length == 0){
                        $('.quickfilters-prev').addClass('hide');
                    }else{
                        $('.quickfilters-prev').removeClass('hide');
                    }
                    setTimeout(() => {
                        updateQuickFiltersNav();
                        console.log('changed changed')
                    }, 200);
                    console.log('changed')
                },
                'scroll': () => {
                    //prevent the user from scrolling
                    console.log('scroll')
                    return false;
                },    
              },
        });
        $(document).on('click', '.quickfilters-next', function(){
            if($('.quickfilter_slider').attr('data-next')){
                var page = parseInt($('.quickfilter_slider').attr('data-next'));
            }else{
                var page = 1;
            }
            
            var totalWidth = 0;
            var containerWidth = $('.quickfilter_slider').outerWidth();
            
            // quickfilterSlider.goto('next');
            $('.quickfilter_slider').attr('data-next', page + 1);
            

            $.each($('.quickfilter_slider .slide'), function(index, value) {
                totalWidth += $(this).outerWidth();
                console.log([totalWidth, parseInt(containerWidth * page)])
                if(totalWidth > containerWidth * page){
                    quickfilterSlider.goto(index - 1);
                    console.log('go to ' + (index - 1))
                    return false;
                }
            });

            console.log('skipped')

            // in case the last slide is not fully visible
            quickfilterSlider.goto('next');

        });
        $(document).on('click', '.quickfilters-prev', function(){
            var page = parseInt($('.quickfilter_slider').attr('data-next'));
            var totalWidth = 0;
            var containerWidth = $('.quickfilter_slider').outerWidth();

            $('.quickfilter_slider').attr('data-next', page - 1);

            $.each($('.quickfilter_slider .slide'), function(index, value) {
                totalWidth += $(this).outerWidth();
                if(totalWidth > containerWidth * (page - 2)){
                    console.log('return back to ' + (index + 1))
                    quickfilterSlider.goto(index + 1);
                    return false;
                }
            });

            quickfilterSlider.goto('prev');
        });
        $(window).on('load', function(){
            setTimeout(() => {
                $('.quickfilters-prev').css('visibility', 'visible');
                $('.quickfilters-next').css('visibility', 'visible');
            }, 700);
        });
    }   

    //Old code

    $(document).on('click', '.shop-top-bar-left-item.filter-btn, .shop-top-bar-right .filter-btn', function(){
        $('.shop-area-mobile-filters-list').addClass('active');
        $('.shop-area-mobile-filters-overlay').addClass('active');
        $('body').css('overflow-y', 'hidden');
        $('html').css('overflow-y', 'hidden');
        console.log('hide scroll')
    });
    $('.products-list-display-filters').append('<div class="close"></div>');
    $('.products-list-display-filters .close').on('click', function() {
        $('.products-list-display-filters').hide();
    });
    $('.shop-area-mobile-filters-submit-btn-secondary').click(function(){
        $('.shop-area-mobile-filters-selected').removeClass('active');

        setTimeout(function(){
            $('.shop-area-mobile-filters-section-selected-container').empty();
            $('.shop-area-mobile-filters-submit-btn-secondary').closest('.shop-area-mobile-filters-submit').removeClass('active');
        }, 300);
    });
    $('.shop-area-mobile-filters-close-secondary').click(function(){
        $('.shop-area-mobile-filters-selected').removeClass('active');

        setTimeout(function(){
            $('.shop-area-mobile-filters-section-selected-container').empty();
            $('.shop-area-mobile-filters-submit-btn-secondary').closest('.shop-area-mobile-filters-submit').removeClass('active');
        }, 300);
    });

    //New code
    function checkParamExists(paramName) {
        var url = new URL(window.location.href);
        if (url.searchParams.has(paramName)) {
            return true;
        } 
        return false;
    }
    function removeParamIfExists(paramName, value) {
        value = value.toString(); // S'assurer que la valeur est traitée comme une chaîne
        var url = new URL(window.location.href);
        if (url.searchParams.has(paramName)) {
            // Obtenir la valeur actuelle du paramètre, la diviser en un tableau, et s'assurer que chaque élément est une chaîne
            var existingValues = url.searchParams.get(paramName).split('~').map(function(item) {
                return item.toString(); // Convertir chaque élément en chaîne pour la comparaison
            });
            // Construire un nouveau tableau en excluant l'identifiant à retirer
            var newValue = existingValues.filter(function(item) {
                return item !== value;
            });
    
            // Vérifier si une valeur a été retirée
            if (newValue.length < existingValues.length) {
                var newValueString = newValue.join('~');
    
                // Gérer la mise à jour ou la suppression du paramètre
                if (newValueString === '') {
                    url.searchParams.delete(paramName);
                    if(paramName === "category"){
                        url.searchParams.delete("catDetail");
                    }
                } else {
                    url.searchParams.set(paramName, newValueString);
                }
                
                window.history.pushState({}, '', url.toString());
                return true; // Retourner true seulement si une valeur a été trouvée et retirée
            }
        }
        return false; // Retourner false si la valeur n'a pas été trouvée ou si aucun changement n'a été fait
    }
    
    


    function getParameterByName(name) {
        var url = new URL(window.location.href);
        return url.searchParams.get(name);
    }

    function initSearch(){
        if($('.shop-area').length > 0){
            if(!checkParamExists("page")){
                addFilterToUrl("page", 1);
            }
            if(!checkParamExists("view")){
                addFilterToUrl("view", 80);
            }

            // if($(window).width() < 768){
            //     $('.shop-top-bar-left-filters').appendTo($('.shop-area-mobile-filters-section-selected'));
            // }
        }
    }
    function addFilterToUrl(category, value){
        if(checkParamExists(category) && category != "page" && category != "view" && category != "sort"){
            var existingValue = new URL(window.location.href).searchParams.get(category);
            value = existingValue + '~' + value;
        }
        var url = new URL(window.location.href);
        url.searchParams.set(category, value);
        window.history.pushState({}, '', url);

        console.log('trigger addFilterToUrl')
    }
    function extractLastDigitFeature(str) {
        var match = str.match(/attributes\.featureId(\d+)/);
        return match ? match[1] : null;
    }

    function updateQuickFiltersSelected(){
        var url = new URL(window.location.href);
        var params = url.searchParams;

        var container = $('.shop-top-bar-left-filters');
        $('.shop-top-bar-left-filters .shop-top-bar-left-item').remove();
        // container.empty();

        // Utiliser forEach pour itérer sur les paramètres
        params.forEach(function(value, key) {
            if(key == "category" || key == "brand" || key == "color" || key.startsWith("feature") || key == "catDetail" || key == "size" || key == "price" || key == "discount" || key == "q"){
                var values = value.split('~');
                $.each(values, function(index2, value2) {
                    var additionalClass = "";
                    if(key == "category"){
                        var name = $('.filter-item[data-filter-key="attributes.catId"][data-filter-value="' + value2 + '"]').first().text();
                    }else if(key == "brand"){
                        var name = $('.filter-item[data-filter-key="attributes.brandId"][data-filter-value="' + value2 + '"]').first().text();
                    }else if(key == "color"){
                        var name = $('.filter-item[data-filter-key="colors"][data-filter-value="' + value2 + '"]').first().text();
                    }else if(key == "size"){
                        var name = $('.filter-item[data-filter-key="attributes.size_uni"][data-filter-value="' + value2 + '"]').first().text();
                    }else if(key == "price"){
                        var name = $('.filter-item[data-filter-key="attributes.priceClass"][data-filter-value="' + value2 + '"]').first().text();
                    }else if(key == "discount"){
                        var name = $('.filter-item[data-filter-key="attributes.discountClass"][data-filter-value="' + value2 + '"]').first().text();
                    }else if(key == "q"){
                        var name = '"' + value2 + '"';
                        additionalClass = " query-item";
                    }else{
                        var name = $('.filter-item[data-filter-value="' + value2 + '"]').first().text();
                    }

                    if (name.length > 30) {
                        name = name.substring(0, 27) + '...';
                    }

                    $('.shop-top-bar-left-smart[data-filter-key="' + key + '"][data-filter-value="' + value2 + '"]').remove();

                    var filterItem = $('<div>', { class: 'shop-top-bar-left-item slide' + additionalClass, 'data-filter-key': key, 'data-filter-value': value2, 'aria-pressed': 'false' });
                    var filterItemText;
                    if (key == "brand") {
                        var nameCapitalized = name.split(' ').map(function(word) {
                            return word.charAt(0).toUpperCase() + word.slice(1);
                        }).join(' ');
                        filterItemText = $('<span>').text(nameCapitalized);
                    } else {
                        filterItemText = $('<span>').text(name);
                    }
                    var filterItemSelector = $('<span>', { class: 'shop-top-bar-left-item-selector', 'data-filter-key': key, 'data-filter-value': value2 });
                    filterItem.append(filterItemText).append(filterItemSelector);
                    if(name != ""){
                        container.prepend(filterItem);
                    }
                });
                if(quickfilterSlider)
                    quickfilterSlider.reset();
                $('.quickfilters-prev').css('visibility', 'visible');
                $('.quickfilters-next').css('visibility', 'visible');
            }
        });
    }

    function constructRequest(attributes) {
        var filterString = '';
        for (var prop in attributes) {
            console.log(prop)
            if (attributes.hasOwnProperty(prop) && attributes[prop].length > 0) {
                if (filterString !== '') {
                    filterString += ' AND ';
                }
                if (prop.startsWith("feature")) {
                    let featureNumber = prop.match(/\d+/)[0]; // Extrait le numéro
                    let featureValues = attributes[prop].join('", "');
                    filterString += `(attributes.featureId${featureNumber}: ANY(\"${featureValues}\"))`;
                } else if (prop === 'color') {
                    filterString += `(colors: ANY(\"${attributes[prop].join('", "')}\"))`;
                } else if (prop === 'category') {
                    filterString += `(attributes.catId: ANY(\"${attributes[prop].join('", "')}\"))`;
                } else if (prop === 'brand') {
                    filterString += `(attributes.brandId: ANY(\"${attributes[prop].join('", "')}\"))`;
                } else if (prop === 'catDetail') {
                    filterString += `(attributes.catDetail: ANY(\"${attributes[prop].join('", "')}\"))`;
                } else if (prop === 'size') {
                    filterString += `(attributes.size_uni: ANY(\"${attributes[prop].join('", "')}\"))`;
                } else if (prop === 'price') {
                    filterString += `(attributes.priceClass: ANY(\"${attributes[prop].join('", "')}\"))`;
                } else if (prop === 'discount') {
                    filterString += `(attributes.discountClass: ANY(\"${attributes[prop].join('", "')}\"))`;
                } else {
                    filterString += `(${prop}: ANY(\"${attributes[prop].join('", "')}\"))`;
                }
            }
        }
        //si je n'ai pas de category dans mon filterString, je rajoute la catégorie par défaut
        if(!filterString.includes('attributes.catId')){
            var categoryDefaultPage = $('.products-list-display-results').data('cat');
            if(categoryDefaultPage){
                if (filterString !== '') {
                    filterString += ' AND ';
                }
                filterString += `(attributes.catId: ANY(\"${categoryDefaultPage}\"))`;
            }
        }
        if(!filterString.includes('attributes.brandId')){
            var brandDefaultPage = $('.products-list-display-results').data('brand');
            if(brandDefaultPage > 0){
                if (filterString !== '') {
                    filterString += ' AND ';
                }
                filterString += `(attributes.brandId: ANY(\"${brandDefaultPage}\"))`;
            }
        }
        if(!filterString.includes('attributes.tag')){
            var tagDefaultPage = $('.products-list-display-results').data('tag');
            if(tagDefaultPage){
                filterString += ` AND (attributes.tag: ANY(\"${tagDefaultPage}\"))`;
            }
        }
        if(!filterString.includes('attributes.model')){
            var modelDefaultPage = $('.products-list-display-results').data('model');
            if(modelDefaultPage){
                filterString += ` AND (attributes.model: ANY(\"${modelDefaultPage}\"))`;
            }
        }
        return filterString;
    }
    
    
    function getResults(){
        var url = new URL(window.location.href);
        var params = url.searchParams;
        var attributes = {};
        var oConstant = JSON.parse(document.querySelector('[constant-json]').innerHTML);

        console.log(quickfilterSlider)

        console.log('getResults')
        console.log(params)
    
        //On récupère les paramètres de l'url
        for (var pair of params.entries()) {
            if(pair[0] == "category" || pair[0] == "brand" || pair[0] == "color" || pair[0].startsWith("feature") || pair[0].startsWith("catDetail") || pair[0].startsWith("price") || pair[0].startsWith("discount") || pair[0].startsWith("size")) {
                // Directement ajouter la valeur ou les valeurs séparées par '~' dans le tableau attributes
                var values = pair[1].split('~');
                if(attributes[pair[0]]){
                    attributes[pair[0]] = attributes[pair[0]].concat(values);
                } else {
                    attributes[pair[0]] = values;
                }
            }
        }
        
        //On construit la requête
        var filterString = constructRequest(attributes);

        if (!attributes.hasOwnProperty('discount')) {
            if (window.location.pathname.includes('/sale')) {
                filterString += ` AND (discount: IN(0.4i, *))`;
            }
        }

        //On récupère les autres paramètres de l'url
        var page = params.get('page');
        var pageSize = params.get('view');
        if(!checkParamExists("sort")){
            var orderBy = "";
        }else{
            var orderBy = params.get('sort');
        }
        if(!checkParamExists("sort") && window.location.pathname.includes('/best-sellers')){
            orderBy = "attributes.externalSales desc";
            filterString += ` AND ( availability: ANY(\"IN_STOCK\") )`;
        }
        if(window.location.pathname.includes('/newness')){
            const sevenDaysAgo = new Date();
            sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
            const formattedDate = sevenDaysAgo.toISOString().slice(0, 10).replace(/-/g, '');

            filterString += ` AND ( availability: ANY(\"IN_STOCK\") ) AND (attributes.activationTimeId: IN(${formattedDate},*) ) AND ( attributes.seasonId: ANY("${oConstant["CURRENT_SEASON_ID"]}") )`;
            if(orderBy == ""){
                orderBy = "attributes.newness desc";
            }
        }

        if(!checkParamExists("q")){
            var query = "";
        }else{
            var query = params.get('q');
        }
        var currentBrand = $('.products-list-display-results').attr('data-brand');
        var currentTag = $('.products-list-display-results').attr('data-tag');
        if($('.shop-area').hasClass('search-page')){
            isSearch = true;
        }else{
            var isSearch = false;
        }

        var baseUrl = window.location.hostname;
        const pathName = window.location.pathname;
        const regex = /\/[^\/]+\/[^\/]+/;
        const geoMatch = pathName.match(regex);
        var pathGeo = '/us/en';
        if ( geoMatch )
            pathGeo = geoMatch[0]

        
        var maxResults = oConstant["SEARCH_MAX_PAGES"]*oConstant["SEARCH_NB_OFFERS_PER_PAGE_DESKTOP"];
        var currentUrl = '' + window.location.pathname + window.location.search;

        $.ajax({
            url: 'https://dev:itrocks@' + baseUrl + pathGeo + '/api/v1/search',
            type: 'POST',
            dataType: 'json',
            headers: {
                'Content-Type': 'application/json'
            },
            data: JSON.stringify({
                facetSpecs: 'colors#all,attributes.catId,attributes.brandId#all,genders,attributes.catDetail#all,attributes.featureIds#all,attributes.size_uni,attributes.priceClass,attributes.discountClass',
                visitorId: '123',
                maxResults: maxResults,
                filter: filterString,
                query: query,
                orderBy: orderBy,
                offset: (page - 1) * pageSize,
                pageSize: pageSize,
                currentBrand: currentBrand,
                currentTag: currentTag,
                output: 'html',
                isSearch: isSearch,
                saveLastListingPage: 'true',
                currentUrl: currentUrl

            }),
            beforeSend: function (xhr) {
                xhr.setRequestHeader("Authorization", "Basic " + btoa("dev:itrocks"));
            },
            success: function (data) {
                updateFilters(data.reponse.enriched_facets);
                updateSelectedFilters(attributes);
                $('.products-list-display-pagination').html(data.pagination); 
                $('.products-list-display-results').html(data.results);
                updateSmartFilters(data.reponse.smart_filters);
                updateQuickFiltersSelected();
                quickfilterSlider.reset();
                quickfilterSlider.update();                
                updateQuickFiltersNav();
                $('.quickfilters-prev').css('visibility', 'visible');
                $('.quickfilters-next').css('visibility', 'visible');

                var oDict = JSON.parse(document.querySelector('[dict-json]').innerHTML);

                var count = data.reponse.totalSize;
                console.log("Nombre de res: " + count)
                if(count == 1){
                    $('.shop-area-mobile-filters-submit-btn-main').text( oDict["see_1_result"] );
                    $('.products-list-display-no_results').hide();
                    $('.products-list-display-pagination').show();
                } else if(count == 0 || !count){
                    $('.products-list-display-no_results').show();
                    $('.products-list-display-pagination').hide();
                } else{
                    $('.products-list-display-no_results').hide();
                    $('.products-list-display-pagination').show();
                    $('.shop-area-mobile-filters-submit-btn-main').text( oDict["see_x_results_left"] + count + oDict["see_x_results_right"]);
                }
                checkMobileFilterVisibility();

                //if there is search param in url we remove the search param
                if(params.has('search')){
                    var url = new URL(window.location.href);
                    url.searchParams.delete('search');
                    window.history.pushState({}, '', url);

                    $('.saveSearchBtn').removeClass('saved').text(oDict["save_this_search"]).attr('data-action', "/us/en/save-search").attr('data-redirect', "/us/en/account/searchs").removeAttr('data-saved');
                }
            },
            error: function (jqXHR, textStatus, errorThrown) {
                console.log('Error: ' + errorThrown);
            }
        });
    }

    function addSubcatFilter(currentCat, subcat){
        var parent = $('.filter-section-catId[data-filter-catid-key="attributes.catId"][data-filter-catid-value="' + currentCat + '"]');

        console.log([currentCat, subcat])

        $.each(subcat, function(index, value) {
            var listItem = $('<li>', { class: 'filter-section-catId subfilter-category', 'data-filter-catid-key': 'attributes.catId', 'data-filter-catid-value': currentCat });
            var link = $('<a>', { class: 'filter-item subcat text-one', 'data-filter-key': 'attributes.catId', 'data-filter-value': value.id }).text(value.name);
            var checkbox = $('<div>', { class: 'filter-item-checkbox' });
            link.prepend(checkbox);
            listItem.append(link);
            parent.append(listItem);
        });
    }


    function checkAndShowCategory(value, parentCategory) {
        $.each(value.subcat, function(index, valueSubcat) {
            filter_container.find('.filter-item[data-filter-key="attributes.catId"][data-filter-value="' + valueSubcat.id + '"]').closest('li').css('display', '');
        });
        console.log([value.id, parentCategory])
        if(value.id == parentCategory) {
            addSubcatFilter(value.id, value.subcat);

            // Si on trouve la catégorie mais qu'elle n'a pas de sous-catégories, on la montre
            if(!value.subcat && !$('.filter-item[data-filter-key="attributes.catId"][data-filter-value="' + value.id + '"]').length > 0){
                var firstVisible = $('.sidebar-widget-list .filter-section-catId').filter(function() {
                    return $(this).css('display') !== 'none';
                  }).first().data('filter-catid-value');

                addSubcatFilter(firstVisible, [value]);
            }

            if(value.subcat){
                return value.subcat.some(subcat => checkAndShowCategory(subcat, parentCategory));
            }

            return true; // Retourne vrai si la catégorie correspond à la catégorie parente
        } else if (value.subcat) {
            // Si la catégorie a des sous-catégories, vérifiez-les récursivement
            return value.subcat.some(subcat => checkAndShowCategory(subcat, parentCategory));
        }
        return false; // Retourne faux si aucune correspondance n'est trouvée
    }

    function updateSelectedFilters(attributes){
        $('.filter-item').removeClass('active');
        $.each(attributes, function(key, value) {
            if(key == "category"){
                var keyName = "attributes.catId";
                var catId = $('.filter-item.subcat').first().closest('li').data('filter-catid-value');
                $('.filter-item:not(.subcat)[data-filter-key="attributes.catId"][data-filter-value="' + catId + '"]').addClass('active');
            }else if(key == "brand"){
                var keyName = "attributes.brandId";
            }else if(key == "color"){
                var keyName = "colors";
            }else if(key.startsWith("feature")){
                var keyName = "attributes.featureId" + key.replace(/\D/g, '');
            }else if(key == "catDetail"){
                var keyName = "attributes.catDetail";
            }else if(key == "size"){
                var keyName = "attributes.size_uni";
            }else if(key == "price"){
                var keyName = "attributes.priceClass";
            }else if(key == "discount"){
                var keyName = "attributes.discountClass";
            }

            $.each(value, function(index, val) {
                $('.filter-item[data-filter-key="' + keyName + '"][data-filter-value="' + val + '"]').addClass('active');
            });
        });
    }

    function updateSmartFilters(facets){

        $('.shop-top-bar-left-smart').remove();

        $.each(facets, function(facetName, values) {    
            // Boucler sur chaque valeur dans le tableau de la facette actuelle
            var container = $('.shop-top-bar-left-filters');

            var smart_filters_types = "";
            var smart_filters_values = "";

            

            console.log(values)
            $.each(values.filters, function(index1, value1) {
                smart_filters_types += value1.type + '|';
                smart_filters_values += value1.value + '|';
            });

            smart_filters_types = smart_filters_types.slice(0, -1);
            smart_filters_values = smart_filters_values.slice(0, -1);

            // if($('.shop-top-bar-left-item[data-filter-key="'+smart_filters_types+'"][data-filter-value="'+smart_filters_values+'"]').length > 0){
            //     console.log('removed: ' + smart_filters_types + ' - ' + smart_filters_values);
            //     return;
            // }

            var filterItem = $('<div>', { class: 'shop-top-bar-left-smart', 'data-filter-key': smart_filters_types, 'data-filter-value': smart_filters_values });
            var filterItemText = $('<span>', { class: 'sub-title-2'}).text(values.name);
            var filterItemSelector = $('<span>', { class: 'shop-top-bar-left-smart-selector', 'data-filter-key': smart_filters_types, 'data-filter-value': smart_filters_values });
            filterItem.append(filterItemText).append(filterItemSelector);
            container.append(filterItem);
        });

    }  

    function createSubcategoryFilterSection(filters, parentName) {
        var container = $('.shop-sidebar-style');
        
        if(!parentName){
            return;
        }
    
        // Créer le conteneur de la section de filtre
        var section = $('<div>', { class: 'sidebar-widget mt-20 mb-20 catDetail-section' });
        var title = $('<h4>', { class: 'pro-sidebar-title active text-one', 'data-cat': 'attributes.catDetail', 'data-brandid': '0', 'data-leaf': '' }).text(parentName);
        var box = $('<div>', { class: 'shop-sidebar-box' });
        var widgetList = $('<div>', { class: 'sidebar-widget-list active' });
        var list = $('<ul>');
    
        // Boucler sur les filtres et ajouter chaque filtre à la liste
        $.each(filters, function(index, filter) {
            var listItem = $('<li>');
            var checkbox = $('<div>', { class: 'filter-item-checkbox' });
            var link = $('<a>', { class: 'filter-item sub-title-2', 'data-filter-key': 'attributes.catDetail', 'data-filter-value': filter.name }).text(filter.name);
            link.prepend(checkbox);
            listItem.append(link);
            list.append(listItem);
        });
    
        // Assembler les éléments
        widgetList.append(list);
        box.append(widgetList);
        section.append(title).append(box);
    
        // Ajouter la section complète au conteneur
        container.children().first().after(section);

        if($(window).width() < 768){
            var mobileFilter = $('<a>', {'data-cat': 'catDetail' }).text(parentName);
            $('.shop-area-mobile-filters-section-entries a[data-cat="catId"]').after(mobileFilter);
        }
    }
    
    
    function updateFilters(facets){

        //find all the .filter-item that have data-filter-key="attributes.featureId*"
        filter_container.find('.pro-sidebar-title[data-cat*="attributes.featureId"]').hide();

        $('.subfilter-category').remove();

        $('.shop-sidebar-style .catDetail-section').remove();
        $('.shop-sidebar-style .filter-item[data-filter-key="attributes.catDetail"]').closest('.sidebar-widget').remove();
        $('.shop-area-mobile-filters-section-entries a[data-cat="catDetail"]').remove();

        var categoryDefaultPage = $('.products-list-display-results').data('cat');
        var parentCategory = getParameterByName('category');
        if(parentCategory == null){
            parentCategory = categoryDefaultPage;
        }
        var parentCategoryName = $('.products-list-display-results').data('catname');

        $.each(facets, function(facetName, values) {    
            // Boucler sur chaque valeur dans le tableau de la facette actuelle
            $.each(values, function(index1, value1) {
                if(index1 == "catId"){
                    var filters_categories = filter_container.find('.filter-item[data-filter-key="attributes.catId"]');
                    filters_categories.closest('li').hide();
                    parentCategoryNameText = $('.filter-item[data-filter-key="attributes.catId"][data-filter-value="' + parentCategory + '"]').first().text();
                    if(parentCategoryNameText != ""){
                        parentCategoryName = parentCategoryNameText;
                    }
                    $.each(value1, function(index2, value2) {
                        if (checkAndShowCategory(value2, parentCategory)) {
                            //console.log('.filter-item[data-filter-key="attributes.catId"][data-filter-value="' + value2.id + '"]');   
                        }
                    });
                }else if(index1 == "brandId"){
                    var filters_brands = filter_container.find('.filter-item[data-filter-key="attributes.brandId"]');
                    filters_brands.closest('.sidebar-widget-list').hide();
                    $.each(value1, function(index2, value2) {
                        filter_container.find('.filter-item[data-filter-key="attributes.brandId"][data-filter-value="' + value2.id + '"]').closest('.sidebar-widget-list').css('display', '');
                    });
                }else if(index1 == "color"){
                    var filters_color = filter_container.find('.filter-item[data-filter-key="colors"]');
                    filters_color.closest('.sidebar-widget-list').hide();
                    $.each(value1, function(index2, value2) {
                        filter_container.find('.filter-item[data-filter-key="colors"][data-filter-value="' + value2.value + '"]').closest('.sidebar-widget-list').css('display', '');
                    });
                }else if(index1 == "size_uni"){
                    var filters_size = filter_container.find('.filter-item[data-filter-key="attributes.size_uni"]');
                    filters_size.closest('.sidebar-widget-list').hide();
                    $.each(value1, function(index2, value2) {
                        filter_container.find('.filter-item[data-filter-key="attributes.size_uni"][data-filter-value="' + value2.value + '"]').closest('.sidebar-widget-list').css('display', '');
                    });
                }else if(index1 == "priceClass"){
                    var filters_price = filter_container.find('.filter-item[data-filter-key="attributes.priceClass"]');
                    filters_price.closest('.sidebar-widget-list').hide();
                    $.each(value1, function(index2, value2) {
                        filter_container.find('.filter-item[data-filter-key="attributes.priceClass"][data-filter-value="' + value2.value + '"]').closest('.sidebar-widget-list').css('display', '');
                    });
                }else if(index1 == "discountClass"){
                    var filters_discount = filter_container.find('.filter-item[data-filter-key="attributes.discountClass"]');
                    filters_discount.closest('.sidebar-widget-list').hide();
                    $.each(value1, function(index2, value2) {
                        filter_container.find('.filter-item[data-filter-key="attributes.discountClass"][data-filter-value="' + value2.value + '"]').closest('.sidebar-widget-list').css('display', '');
                    });
                }else if(extractLastDigitFeature(index1)){
                    var filters_feature = filter_container.find('.filter-item[data-filter-key="attributes.featureId' + extractLastDigitFeature(index1) + '"]');
                    filters_feature.closest('.sidebar-widget-list').hide();
                    $.each(value1, function(index2, value2) {
                        filter_container.find('.pro-sidebar-title[data-cat="' + index1 + '"]').show();
                        filter_container.find('.filter-item[data-filter-key="attributes.featureId' + extractLastDigitFeature(index1) + '"][data-filter-value="' + value2.name + '"]').closest('.sidebar-widget-list').css('display', '');
                    });
                }else if(index1 == "catDetail"){
                    createSubcategoryFilterSection(value1, parentCategoryName);
                }
            });
        });

    }        
    
    function checkMobileFilterVisibility(){
        if($(window).width() < 768){
            $('.shop-area-mobile-filters-section-entries a').each(function(){
                var category = $(this).data('cat');
                if($('.pro-sidebar-title[data-cat="attributes.' + category + '"]').css('display') === 'none'){
                    $(this).hide();
                }else{
                    $(this).show();
                }
            });
        }
    }

    $(document).on('filter_changed', function(){
        console.log('updated')
        $('.shop-area-mobile-filters-submit').addClass('active');

        // setTimeout(function(){
        //     if($(window).width() < 768){
        //         let number_filters = $('.shop-top-bar-left-filters .shop-top-bar-left-item').length;
        //         if(number_filters == 1){
        //             $('.filter-btn-number_filters').text( number_filters + ' ' + oDict["pdt_filter_1_filter_active"] );
        //         }else if(number_filters > 1){
        //             $('.filter-btn-number_filters').text( number_filters + ' ' + oDict["pdt_filter_multiple_filter_active"] );
        //         }else{
        //             $('.filter-btn-number_filters').text('');
        //         }
        //     }
        // }, 500);
    });
    $('.shop-area-mobile-filters-submit-btn-main').click(function(){
        $('.shop-area-mobile-filters-list').removeClass('active');
        $('.shop-area-mobile-filters-overlay').removeClass('active');
        $('body').css('overflow', '');
        $('html').css('overflow-y', '');
    });
    $('.shop-area-mobile-filters-list .shop-area-mobile-filters-close-main').click(function(){
        $('.shop-area-mobile-filters-list').removeClass('active');
        $('.shop-area-mobile-filters-overlay').removeClass('active');
        $('body').css('overflow', '');
        $('html').css('overflow-y', '');
    });

    initSearch();

    $(document).on('click', '.filter-item', function(){
        var category = $(this).data('filter-key');
        var value = $(this).data('filter-value');

        setTimeout(() => {
            $("#brandSearch").val("");
            $("#brandSearch").trigger("input");
        }, timeout = 2000);

        $(this).trigger('filter_changed');

        // $(this).addClass('active');

        addFilterToUrl('page', 1);
        
        if(category == "attributes.catId"){
            if(checkParamExists('category')){
                let cookieValue = getParameterByName('category');
                //delete the parameter category
                var url = new URL(window.location.href);
                url.searchParams.delete('category');
                url.searchParams.delete('catDetail');
                window.history.pushState({}, '', url);
                if(cookieValue != value){
                    addFilterToUrl('category', value);
                }
            }else{
                addFilterToUrl('category', value);
            }
        }else if(category == "attributes.brandId"){
            //add brand filter in url
            if(!removeParamIfExists('brand', value))
                addFilterToUrl('brand', value);
        }else if(category == "colors"){
            //add price filter in url
            if(!removeParamIfExists('color', value))
                addFilterToUrl('color', value);
        }else if(category == "attributes.size_uni"){
            //add price filter in url
            if(!removeParamIfExists('size', value))
                addFilterToUrl('size', value);
        }else if(category == "attributes.priceClass"){
            //add price filter in url
            if(!removeParamIfExists('price', value))
                addFilterToUrl('price', value);
        }else if(category == "attributes.discountClass"){
            //add price filter in url
            if(!removeParamIfExists('discount', value))
                addFilterToUrl('discount', value);
        }else if(category == "attributes.catDetail"){
            //add price filter in url
            if(!removeParamIfExists('catDetail', value))
                addFilterToUrl('catDetail', value);
        }else if(category && extractLastDigitFeature(category)){
            //add feature filter in url
            if(!removeParamIfExists('feature' + extractLastDigitFeature(category), value))
                addFilterToUrl('feature' + extractLastDigitFeature(category), value);
        }

        getResults();

        if($('.saveSearchBtn').data('saved')){
            $('.saveSearchBtn').text(oDict["save_this_search"]).removeClass('saved').attr('data-saved', '');
            var url = new URL(window.location.href);
            url.searchParams.delete('search');
            window.history.pushState({}, '', url);
        }
    });


    $(document).on('click', '.shop-short-by a', function(){
        var value = $(this).data('sort');
        addFilterToUrl('page', 1);
        $('.shop-short-by span').text($(this).text());
        if(value != null && value != ""){
            if(!removeParamIfExists('sort', value))
                addFilterToUrl('sort', value);
        }else{
            var url = new URL(window.location.href);
            url.searchParams.delete('sort');
            window.history.pushState({}, '', url);
        }
        
        getResults();
    });

    $('.shop-area-mobile-filters-section-sort input[type=radio][name=sort]').change(function() {
        var value = $(this).data('sort-mobile');
        addFilterToUrl('page', 1);
        if(value != null && value != ""){
            if(!removeParamIfExists('sort', value))
                addFilterToUrl('sort', value);
        }else{
            var url = new URL(window.location.href);
            url.searchParams.delete('sort');
            window.history.pushState({}, '', url);
        }
        getResults();
    });

    $(document).on('click', '.products-list-display-pagination .previous', function(){
        var page = getParameterByName('page');
        if(page > 1){
            addFilterToUrl('page', parseInt(page) - 1);
            getResults();
        }

        if($(".shop-area-title").length > 0){
            var scrollingElementTop = $(".shop-area-title").offset().top;
        }else{
            var scrollingElementTop = $(".shop-area").offset().top;
        }
        $("html, body").animate({
            scrollTop: scrollingElementTop
        }, 1000);
    });

    $(document).on('click', '.products-list-display-pagination .next', function(){
        var page = getParameterByName('page');
        addFilterToUrl('page', parseInt(page) + 1);
        getResults();

        if($(".shop-area-title").length > 0){
            var scrollingElementTop = $(".shop-area-title").offset().top;
        }else{
            var scrollingElementTop = $(".shop-area").offset().top;
        }
        $("html, body").animate({
            scrollTop: scrollingElementTop
        }, 1000);
    });

    $(document).on('click', '.shop-top-bar-left-item:not(.filter-btn)', function(){
        console.log('click slide')
        var category = $(this).data('filter-key');
        var value = $(this).data('filter-value');
        removeParamIfExists(category, value)
        getResults();
    });

    $(document).on('click', '.shop-top-bar-left-smart', function(){
        var category = $(this).data('filter-key');
        var value = $(this).data('filter-value');

        //if category has the caracter | then we split
        if(category.includes('|')){
            var categoryArray = category.split('|');
            var valueArray = value.split('|');
            for (var i = 0; i < categoryArray.length; i++) {
                addFilterToUrl(categoryArray[i], valueArray[i]);
            }
        }else{
            addFilterToUrl(category, value);
        }
        
        getResults();
    });

    // MOBILE

    $(document).on('click', '.shop-area-mobile-filters-section-entries a', function(e){
        e.preventDefault();
    
        $('.shop-area-mobile-filters-selected').addClass('active');
    
        var container = $('.shop-area-mobile-filters-section-selected-container');
        var category = $(this).data('cat');
        category = "attributes." + category;
        
        // Sélectionner la section
        var section = $('.pro-sidebar-title[data-cat="' + category + '"]').addClass('active').parent();
        section.find('.sidebar-widget-list').addClass('active');
        
        // Cloner la section et s'assurer que le conteneur est vidé avant d'ajouter le clone
        container.empty();
        var sectionClone = section.clone();
        container.append(sectionClone);
    });
    
    window.addEventListener('popstate', function(event) {
        // Retirer le dernier filtre basé sur l'URL ou l'état stocké dans event.state
        var currentUrl = document.location;
        console.log('popstate getResults')
        // Mettre à jour l'affichage selon l'URL actuelle sans rafraîchir la page
        getResults();
    });
    
    function initSelectedFilters(){
        var url = new URL(window.location.href);
        var params = url.searchParams;
        var attributes = {};
    
        //On récupère les paramètres de l'url
        for (var pair of params.entries()) {
            if(pair[0] == "category" || pair[0] == "brand" || pair[0] == "color" || pair[0].startsWith("feature") || pair[0].startsWith("size") || pair[0].startsWith("catDetail")) {
                // Directement ajouter la valeur ou les valeurs séparées par '~' dans le tableau attributes
                var values = pair[1].split('~');
                if(attributes[pair[0]]){
                    attributes[pair[0]] = attributes[pair[0]].concat(values);
                } else {
                    attributes[pair[0]] = values;
                }
            }
        }
        updateSelectedFilters(attributes);
        updateQuickFiltersSelected();
    }
    initSelectedFilters();


    /***** AUTO SUGGEST SEARCH */
    var currentUrl = window.location.href;
    if(currentUrl.indexOf("/men") !== -1) {
        $('.search-modal-autosuggest-tabs-item[data-gender="men"]').addClass('active');
        $('.search-modal-autosuggest-searchs').hide();
        $('.search-modal-autosuggest-searchs[data-gender="men"]').show();

        $('.search-modal-autosuggest-results').hide();
        $('.search-modal-autosuggest-results[data-gender="men"]').show();
    } else if(currentUrl.indexOf("/women") !== -1) {
        $('.search-modal-autosuggest-tabs-item[data-gender="women"]').addClass('active');
        $('.search-modal-autosuggest-searchs').hide();
        $('.search-modal-autosuggest-searchs[data-gender="women"]').show();

        $('.search-modal-autosuggest-results').hide();
        $('.search-modal-autosuggest-results[data-gender="women"]').show();
    } else if(gender_page_data){
        $('.search-modal-autosuggest-tabs-item[data-gender="' + gender_page_data + '"]').addClass('active');
        $('.search-modal-autosuggest-searchs').hide();
        $('.search-modal-autosuggest-searchs[data-gender="' + gender_page_data + '"]').show();

        $('.search-modal-autosuggest-results').hide();
        $('.search-modal-autosuggest-results[data-gender="' + gender_page_data + '"]').show();
    }else{
        $('.search-modal-autosuggest-searchs').hide();
    }

    let typingTimer; 
    const doneTypingInterval = 500;
    $('input[name="q"]').on('input', function() {
        clearTimeout(typingTimer);
        const inputValue = $(this).val(); 
        typingTimer = setTimeout(function() {
            $(document).trigger('autosuggest', [inputValue]);
        }, doneTypingInterval);
    });

    $('.search-modal-autosuggest-tabs-item').click(function(){
        let gender = $(this).data('gender');

        $('.search-modal-autosuggest-results').hide();
        $('.search-modal-autosuggest-results[data-gender="'+gender+'"').show();


        $('.search-modal-autosuggest-tabs-item').removeClass('active');
        $(this).addClass('active');
        // $(document).trigger('autosuggest', [$('.search-form input[name="q"]').val()]);

        
        $('.search-modal-autosuggest-searchs').hide();
        if($('input[name="q"]').val().length < 2){
            $('.search-modal-autosuggest-searchs[data-gender="' + gender + '"]').show();
        }

        const inputValue = $('input[name="q"]').val(); 
        $(document).trigger('autosuggest', [inputValue]);
    });

    $(document).on('autosuggest', function(event, inputValue){
        var value = inputValue;
        if(value.length > 1){
            var baseUrl = window.location.hostname;
            const pathName = window.location.pathname;
            const regex = /\/[^\/]+\/[^\/]+/;
            const geoMatch = pathName.match(regex);
            var pathGeo = '/us/en';
            if ( geoMatch )
                pathGeo = geoMatch[0]

            var oConstant = JSON.parse(document.querySelector('[constant-json]').innerHTML);
            var maxResults = oConstant["SEARCH_MAX_PAGES"]*oConstant["SEARCH_NB_OFFERS_PER_PAGE_DESKTOP"];

            $.ajax({
                url: 'https://dev:itrocks@' + baseUrl + pathGeo + '/api/v1/suggest',
                type: 'POST',
                dataType: 'json',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: JSON.stringify({
                    keyword: value,
                    gender: $('.search-modal-autosuggest-tabs-item.active').data('gender')
                }),
                beforeSend: function (xhr) {
                    xhr.setRequestHeader("Authorization", "Basic " + btoa("dev:itrocks"));
                },
                success: function (data) {
                    console.log(data);
                    $('.search-modal-autosuggest-searchs').hide();
                    $('.search-modal-autosuggest-results ul').empty();

                    let results = data.completionResults;
                    let htmlMen = '';
                    let htmlWomen = '';
                    let additionalFilter = '';

                    for (let i = 0; i < results.length; i++) {

                        additionalFilter = '';
                        for (const key in results[i].attributes) {
                            if(key == "catDetail"){
                                additionalFilter += "catDetail=" + results[i].attributes[key].replace(/ /g, '+');
                            }
                            if (key.startsWith('featureId')) {
                                const featureId = key.replace('featureId', '');
                                const value = results[i].attributes[key];

                                if(additionalFilter != ''){
                                    additionalFilter += "&";
                                }
                                additionalFilter += "feature" + featureId + "=" + value;
                            }
                        }

                        if($.inArray("male", results[i].attributes.genders) !== -1){
                            if(additionalFilter == ''){
                                htmlMen += '<li><a href="' + results[i].url + '">' + results[i].suggestion.replace(new RegExp(value, 'gi'), function(match) {
                                    return '<strong>' + match + '</strong>';
                                  }) + '</a></li>';
                            }else{
                                htmlMen += '<li><a href="' + results[i].url + '?' + additionalFilter + '">' + results[i].suggestion.replace(new RegExp(value, 'gi'), function(match) {
                                    return '<strong>' + match + '</strong>';
                                  }) + '</a></li>';
                            }
                        }
                        if($.inArray("female", results[i].attributes.genders) !== -1){
                            if(additionalFilter == ''){
                                htmlWomen += '<li><a href="' + results[i].url + '">' + results[i].suggestion.replace(new RegExp(value, 'gi'), function(match) {
                                    return '<strong>' + match + '</strong>';
                                  }) + '</a></li>';
                            }else{
                                htmlWomen += '<li><a href="' + results[i].url + '?' + additionalFilter + '">' + results[i].suggestion.replace(new RegExp(value, 'gi'), function(match) {
                                    return '<strong>' + match + '</strong>';
                                  }) + '</a></li>';
                            }
                        }
                    }
                    let active_gender = $('.search-modal-autosuggest-tabs-item.active').data('gender');
                    $('.search-modal-autosuggest-results[data-gender="men"] ul').html(htmlMen);
                    $('.search-modal-autosuggest-results[data-gender="women"] ul').html(htmlWomen);
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    console.log('Error: ' + errorThrown);
                }
            });
            
        }else {
            $('.search-modal-autosuggest-results ul').empty();
            let gender = $('.search-modal-autosuggest-tabs-item.active').data('gender');
            $('.search-modal-autosuggest-searchs[data-gender="' + gender + '"]').show();
            return;
        }
    });

    $('.search-form').on('submit', function(e) {
        e.preventDefault();
        var input = $(this).find('input[type="search"]');
        input.val(input.val().trim().replace(/\s+/g, ' '));
        if(input.val() != '') {

            var gender = "all"
            if($('.search-modal-autosuggest-tabs-item.active').data('gender')){
                var gender = $('.search-modal-autosuggest-tabs-item.active').data('gender');
            }else if(gender_page_data){
                var gender = gender_page_data;
            }

            var url = $(this).attr('action') + gender + '?q=' + input.val();
            var name = input.val();
            

            var currentUrl = window.location.href;
            var urlObject = new URL(currentUrl);
            var baseUrl = urlObject.origin;

            $.ajax({
                url: baseUrl + "/add-recently-searched",
                type: 'POST',
                data: {name: name, url: url, gender: gender},
                success: function(data, status, xhr) {
                    if (xhr.status === 201) {
                        window.location.href = url;
                    } else {
                        console.log('AJAX error: ' + xhr.status); 
                        window.location.href = url;             
                    }
                },
                error: function(xhr, status, error) {
                    console.log('AJAX error: ' + error);
                    window.location.href = url;
                }
            });
        
            
        }
    });


    $('#search-modal .search-icon').click(function(e) {
        e.preventDefault();
        if($('#search-modal form.search-form input[type="search"]').val() != '') {
            $('#search-modal form.search-form').submit();
        }
    });

    $(document).on('click', '.search-modal-autosuggest-results ul li a', function(e){
        e.preventDefault();
        var url = $(this).attr('href');
        var name = $(this).text();
        var gender = $('.search-modal-autosuggest-tabs-item.active').data('gender');

        var currentUrl = window.location.href;
        var urlObject = new URL(currentUrl);
        var baseUrl = urlObject.origin;

        $.ajax({
            url: baseUrl + "/add-recently-searched",
            type: 'POST',
            data: {name: name, url: url, gender: gender},
            success: function(data, status, xhr) {
                if (xhr.status === 201) {
                    window.location.href = url;
                } else {
                    console.log('AJAX error: ' + xhr.status);   
                    window.location.href = url;           
                }
            },
            error: function(xhr, status, error) {
                console.log('AJAX error: ' + error);
                window.location.href = url;
            }
        });

    });

});